import styled from "styled-components";

export const PaginatorContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-inline: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding-top: 10px;
  max-height: 58px;
`;

